export default __webpack_public_path__ + "static/media/avatarB6.429ca7b1.png";